module.exports = __webpack_public_path__ + "images/young-entrepreneur-92947b.png";